import { useEffect, useCallback, type RefObject } from "react";

export function useDismissable({
  open,
  onClose,
  ref,
}: {
  open: boolean;
  onClose: () => void;
  ref: RefObject<HTMLElement | null>;
}) {
  const stableClose = useCallback(onClose, [onClose]);

  useEffect(() => {
    if (!open) return undefined;
    function handleMouseDown(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        stableClose();
      }
    }
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") {
        stableClose();
      }
    }
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, stableClose, ref]);
}
